var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
/* eslint-disable no-restricted-imports */
/** @description: Tech debt, this should be moved outside the ui folder */
import authentication from "@irati/auth";
/* eslint-enable no-restricted-imports */
import Flex from "../../Flex";
import ProfilePic from "../../ProfilePicture";
import { Dosis } from "../../global/fonts";
var Name = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 21px;\n  margin-left: 10px;\n  ", ";\n"], ["\n  font-size: 21px;\n  margin-left: 10px;\n  ", ";\n"])), Dosis);
var ProfileHeader = function () {
    var user = authentication.user();
    return (React.createElement(Flex, { alignItems: "center", padding: "10px 0" },
        React.createElement(ProfilePic, { user: user, small: true }),
        React.createElement(Name, null, firstnameLastname(user))));
};
export default ProfileHeader;
var templateObject_1;
